import React, {useState} from "react";
import S from './Program.module.scss';
import {Tabs} from '@mantine/core';
import {ProgramPanelOne} from "./ProgramPanelOne";
import {ProgramPanelTwo} from "./ProgramPanelTwo";
import {ProgramPanelTree} from "./ProgramPanelTree";
import blur from "../../shared/assets/images/blur.jpg";
import {ModalWindow} from "../modal";
import {useDisclosure} from "@mantine/hooks";

interface ProgramProps {
  event?: any;
  program?: any;
}

export const Program = ({event, program}: ProgramProps) => {
  const [value, setValue] = useState<string | null>('1');
  const [openedModal, {open: openModal, close: closeModal}] = useDisclosure(false);
  return (
      <div className={S.boxContent}>
        <div className={S.titleBox}>
          <div className={S.title}>ПРОГРАММА</div>
          <Tabs variant="none" value={value} onChange={setValue}>
            <Tabs.List className={S.list}>
              <Tabs.Tab value="1" className={event === 5 ? S.tabLogistics : S.tab}>
                1 ДЕНЬ
              </Tabs.Tab>
              <Tabs.Tab value="2" className={event === 5 ? S.tabLogistics : S.tab}>
                2 ДЕНЬ
              </Tabs.Tab>
              <Tabs.Tab value="3" className={event === 5 ? S.tabLogistics : S.tab}>
                3 ДЕНЬ
              </Tabs.Tab>
            </Tabs.List>
          </Tabs>
        </div>
        {program ? (
            <div>
                {value === '1' && <ProgramPanelOne event={event} />}
                {value === '2' && <ProgramPanelTwo event={event} />}
                {value === '3' && <ProgramPanelTree event={event} />}
            </div>
        ) : (
            <div className={S.divProgram}>
              <div className={event === 5 ? S.programTextLogistics : S.programText}>
                Программа мероприятия <span onClick={openModal}>по запросу.</span>
              </div>
              <img src={blur} alt="program"/>
            </div>
        )}
        <ModalWindow
            opened={openedModal}
            close={closeModal}
            titleModal="Запросить программу"
            event={event}
            question={true}
            textMessage="Отправьте, пожалуйста, программу мероприятия."
        />
      </div>
  );
};